<template>
 <div>
    <div class="nav">
      <div class="top">
        <div class="icon" @click="showTip = true">
          <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          <span>{{$t('quicklyCreate')}}</span>
        </div>
        <div class="btn" @click="quickCreate">{{$t('confirmCreate')}}</div>
      </div>
      <div class="bottom">
        <img src="@/assets/images/common/fast_bg.png" alt="">
        <vuedraggable v-model="createArr" class="wrapper" v-bind="{ group: { name: 'tutorial', put: true} }">
          <div v-for="(item, index) in createArr" :key="index" class="item">
            <img :src="item.coverImgUrl" alt="" @error="item.coverImgUrl = placeHolderImg">
            <div class="clear" @click="clearStep(index,item.uuid)"><i class="el-icon-close"></i></div>
            <p class="step">{{$t('Link')}}：{{item.drillTitle || '---'}}</p>
          </div>
        </vuedraggable>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <img src="@/assets/images/common/fast_tag.png" alt="">
        {{$t('queryTrainingContent')}}
      </div>
      <div class="tutorial_wrap">
        <div class="left">
          <vue-scroll>
            <div class="search_wrap">
              <select v-model="drillCategoryId" @change="changeQuery(true)">
                <option value="">{{$t('classifications')}}</option>
                <option
                  v-for="(item, index) in tutorialType"
                  :key="index"
                  :value="item.id">{{$t('type')}}-{{item.nameZh}}</option>
              </select>
              <select v-model="language" @change="changeQuery(true)">
                <option value="">{{$t('language')}}-{{$t('all')}}</option>
                <option value="zh">{{$t('language')}}-{{$t('Chinese')}}</option>
                <option value="en">{{$t('language')}}-{{$t('English')}}</option>
              </select>
              <select v-model="skillLevelId" @change="changeQuery(true)">
                <option value="">{{$t('team1')}}-{{$t('teams')}}</option>
                <option
                  v-for="(item,index) in squadNameList"
                  :key="index"
                  :value="item.id">{{$t('team1')}}-{{item.nameZh}}</option>
              </select>
              <div class="line"></div>
              <input
                v-model="keyword"
                type="text"
                :placeholder="$t('keyWordsPlaceholder')"
                @keyup.enter="searchTutorial">
              <el-button
                icon="el-icon-search"
                type="primary"
                style="font-size: 16px;border: 0;border-radius:0;width:100px;margin: 20px 0"
                @click="searchTutorial">{{$t('search')}}</el-button>
              <div class="line"></div>
              <div class="show">
                <p>{{$t('show')}}</p>
                <div><input v-model="showInfo[0]" type="checkbox"><label></label>{{$t('planTitle')}}</div>
                <div><input v-model="showInfo[1]" type="checkbox" checked><label></label>{{$t('linkTitle')}}</div>
                <div><input v-model="showInfo[2]" type="checkbox"><label></label>{{$t('author')}}</div>
                <div><input v-model="showInfo[3]" type="checkbox"><label></label>{{$t('lastUpdateTime')}}</div>
              </div>
            </div>
          </vue-scroll>
        </div>
        <div class="right">
          <div class="scroll_wrap">
            <vue-scroll v-show="dataReady">
              <vuedraggable
                v-model="tutorial"
                class="wrapper"
                v-bind="{ group: { name: 'tutorial', pull: 'clone', put: false}, filter: '.disabled'}"
                @end="disabledTutorial">
                <div
                  v-for="(item, index) in tutorial"
                  :key="index"
                  :class="item.disabled ? 'disabled' : ''"
                  class="item">
                  <img :src="item.coverImgUrl" alt="" @error="item.coverImgUrl = placeHolderImg">
                  <div class="mask"></div>
                  <p v-show="showInfo[0]" :title="item.title">{{$t('planTitle')}}：{{item.title}}</p>
                  <p v-show="showInfo[1]" :title="item.drillTitle">{{$t('linkTitle')}}：{{item.drillTitle}}</p>
                  <p v-show="showInfo[2]"  :title="item.authorName">{{$t('author')}}：{{item.authorName}}</p>
                  <p v-show="showInfo[3]" :title="item.updatedAt | time">{{$t('lastUpdateTime')}}：{{item.updatedAt | time}}</p>
                  <p class="detail" @click="tutorialDetial(index)">[{{$t('lookDetail')}}]</p>
                </div>
              </vuedraggable>
            </vue-scroll>
            <yioks-empty v-if="empty"></yioks-empty>
            <yioks-loading v-if="loading"></yioks-loading>
          </div>
          <Pagination :total="total" :page.sync="page"/>
        </div>
      </div>
    </div>
    <yioks-tip :showTip="showTip" :tipMsg="$t('waivedSubmission')" @callback="isBack"></yioks-tip>
    <yioks-tip
      :showTip="stepLimt"
      :tipMsg="$t('planLimitTips')"
      :confirmBtn="$t('iKnow')"
      @callback="stepLimt = false"></yioks-tip>
    <el-dialog
    :visible.sync="showDetail"
    width="700px"
    :close-on-click-modal="false"
    custom-class="yioks_alert3">
      <div class="detail_wrap" >
        <vue-scroll :ops="ops">
          <div class="title">{{$t('linkTitle')}}: {{tutorialItme.drillTitle}}</div>
          <div class="detail">
            <div class="tutorial_wrap">
              <!--<template v-if="flashFlag">-->
                <!--<object-->
                  <!--:key="tutorialItme.id"-->
                  <!--type="application/x-shockwave-flash"-->
                  <!--name="sspviewer"-->
                  <!--align="middle"-->
                  <!--:data="`${hostUrl}/uploads/flash-tool/yioks-football-view.swf?revision=1463`"-->
                  <!--width="337"-->
                  <!--height="207">-->
                  <!--<param name="quality" value="high">-->
                  <!--<param name="bgcolor" value="#000000">-->
                  <!--<param name="play" value="false">-->
                  <!--<param name="loop" value="false">-->
                  <!--<param name="wmode" value="transparent">-->
                  <!--<param name="scale" value="showall">-->
                  <!--<param name="menu" value="true">-->
                  <!--<param name="devicefont" value="false">-->
                  <!--<param name="salign" value="">-->
                  <!--<param name="allowscriptaccess" value="sameDomain">-->
                  <!--<param name="allowfullscreen" value="true">-->
                  <!--<param name="flashvars" :value="`xmlRequestFile=/api/editor/myXmlView?sessionUuid=${tutorialItme.sessionUuid}&screenSortOrder=${tutorialItme.sortOrder}`">-->
                <!--</object>-->
              <!--</template>-->
              <!--<template v-if="!flashFlag">-->
                <!--<flash-tips :min="true"></flash-tips>-->
              <!--</template>-->
            </div>
            <img class="placeholder_img" :src="tutorialItme.coverImgUrl" @error="tutorialItme.coverImgUrl = placeHolderImg">
            <div class="info">
              <p>{{$t('planTitle')}}: {{tutorialItme.title}}</p>
              <p>{{$t('linkTitle')}}: {{tutorialItme.drillTitle}}</p>
              <p>{{$t('author')}}: {{tutorialItme.authorName}}</p>
            </div>
          </div>
          <p class="description">{{$t('linkDescription')}}</p>
          <div style="margin-right:20px" v-html="tutorialItme.drillComment"></div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import 'vue-awesome/icons/regular/arrow-alt-circle-left'
import vuedraggable from 'vuedraggable'
import tutorial from '@/api/tutorial'
import placeHolderImg from '@/assets/images/common/plan_default.png'
import { flashCheck } from '@/utils/yioks_filter'

export default {
  components: {
    vuedraggable,
    'Pagination': () => import('@/components/Pagination'),
    'FlashTips': () => import('@/components/FlashTips')
  },
  data () {
    return {
      flashFlag: false,
      showTip: false,
      createArr: [],
      tutorial: [],
      total: 0,
      page: 0,
      showInfo: [true, true, false, false],
      tutorialType: [],
      squadNameList: [],
      loading: true,
      dataReady: false,
      empty: false,
      placeHolderImg,
      language: '',
      drillCategoryId: '',
      keyword: '',
      skillLevelId: '',
      stepLimt: false,
      disabledStep: {},
      showDetail: false,
      tutorialItme: '',
      hostUrl: process.env.VUE_APP_URL,
      sessionKind: this.$route.query.sessionKind,
      ops: { // vue-scroll样式
        rail: {
          background: '#000',
          opacity: 0.2
        },
        bar: {
          background: '#000',
          opacity: 0.3
        }
      }
    }
  },
  watch: {
    keyword (val) {
      if (!val) {
        this.changeQuery(true)
      }
    },
    page () {
      this.changeQuery()
    },
    createArr (val) {
      if (this.createArr.length > 5) {
        this.stepLimt = true
        this.createArr.splice(5, 1)
      }
    }
  },
  created () {
    this.flashFlag = flashCheck()
    this.getCommon()
    this.getTutorial()
  },
  methods: {
    getCommon () {
      const { page, keyword, language, skillLevelId, drillCategoryId } = this.$route.query
      page && (this.page = Number(page))
      keyword && (this.keyword = keyword)
      language && (this.language = language)
      skillLevelId && (this.skillLevelId = skillLevelId)
      drillCategoryId && (this.drillCategoryId = drillCategoryId)
      
      tutorial.getCategory().then(res => {
        this.tutorialType = res.map(item => {
          return {
            ...item,
            nameZh: item.nameZh
          }
        })
      })
      tutorial.getCoachSkill().then(res => {
        this.squadNameList = res.map(item => {
          return {
            ...item,
            shortName: '球队-' + item.shortName
          }
        })
      })
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          keyword: this.keyword,
          language: this.language,
          skillLevelId: this.skillLevelId,
          drillCategoryId: this.drillCategoryId
        }
      })
      this.getTutorial()
    },
    getTutorial () {
      this.loading = true
      this.dataReady = false
      this.empty = false
      tutorial.quicklyTeachingList({
        drillCategoryId: this.drillCategoryId,
        keyword: this.keyword,
        language: this.language,
        page: this.page,
        skillLevelId: this.skillLevelId
      }).then(res => {
        this.loading = false
        this.total = res.totalElements
        if (res.totalElements) {
          this.dataReady = true
          this.tutorial = res.content
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    isBack (isSure) {
      if (isSure) {
        this.$router.go(-1)
      }
      this.showTip = false
    },
    searchTutorial () {
      if (!this.keyword) return
      this.changeQuery(true)
    },
    clearStep (index, uuid) {
      this.createArr.splice(index, 1)
      this.tutorial = this.tutorial.map(item => {
        if (item.uuid === uuid) {
          item.disabled = false
        }
        return item
      })
    },
    disabledTutorial (add) {
      if (add.pullMode === 'clone') {
        let itemUuid = this.tutorial[add.oldIndex].uuid
        this.tutorial = this.tutorial.map(item => {
          if (item.uuid === itemUuid) {
            item.disabled = true
          }
          return item
        })
      }
    },
    quickCreate () {
      let stepArr = ''
      this.createArr.forEach(item => {
        stepArr += item.uuid + ','
      })
      // this.$router.push({
      //   path: 'quickCreate',
      //   query: {
      //     sessionKind : this.sessionKind,
      //     uuid: stepArr.substr(0, stepArr.length - 1)
      //   }
      // })
      window.location.href = `/static/session_editor/sspeditor.html?uid=${stepArr.substr(0, stepArr.length - 1)}&sessionKind=${this.sessionKind}&quick=quick`
      
    },
    tutorialDetial (index) {
      this.tutorialItme = this.tutorial[index]
      this.showDetail = true
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .nav
    color #FFF
    background $black_color
    font-size .18rem
    width $nav_width
    margin .1rem 0 .3rem
    box-sizing border-box
    padding .2rem
    overflow hidden
    .top
      display flex
      justify-content space-between
      padding-bottom .1rem
      .icon
        display flex
        align-items center
        cursor pointer
        span
          padding-left .2rem
      .btn
        background $green_color2
        padding .1rem .2rem
        cursor pointer
        font-size .16rem
    .bottom
      border-top 1px solid #FFF
      margin-left .4rem
      padding-top .2rem
      position relative
      &>img
        width 8.05rem
        height 1rem
        // pointer-events none
      .wrapper
        display flex
        position absolute
        top .1rem
        left 0
        width 10rem
        height 1rem
        overflow hidden
        padding-top .1rem
        .item
          width 1.41rem
          height 1rem
          border-radius .05rem
          margin-right .25rem
          position relative
          &:hover > .step,&:hover > .clear
            display block
          &:last-child
            margin 0
          img
            width 100%
            height 100%
            border-radius .05rem
          .clear
            width .2rem
            height .2rem
            background $green_color
            color #FFF
            position absolute
            border-radius .1rem
            text-align center
            line-height .2rem
            font-size .12rem
            right -.1rem
            top -.1rem
            cursor pointer
            display none
          .step
            position absolute
            top 0
            left 0
            font-size .14rem
            color #000
            padding .05rem .1rem 0
            display none

  .content
    color #FFF
    font-size .16rem
    background $black_color
    box-sizing border-box
    width $nav_width
    height 4.6rem
    position relative
    display flex
    flex-direction column
    padding-left .25rem
    .title
      display flex
      align-items center
      padding .2rem 0
      font-size .18rem
      img
        margin-right .1rem
    .tutorial_wrap
      display flex
      flex 1
      z-index 1
      .left
        height 3.85rem
        overflow hidden
        border-right 1px solid #FFF
        .search_wrap
          padding-right .3rem
          display flex
          flex-direction column
          align-items center
          input,select
            display block
            width 2.04rem
            height .4rem
            margin-bottom .18rem
            border 0
            outline none
            padding-left .1rem
            box-sizing border-box
          .line
            border-top 1px solid #FFF
            padding-bottom .2rem
            width 100%
          .show
            width 100%
            p
              font-size .2rem
              margin-bottom .2rem
            div
              display flex
              position relative
              align-items center
              user-select none
              margin-bottom .2rem
              input
                position absolute
                width .2rem
                height .2rem
                cursor pointer
                opacity 0
                z-index 1
                &:checked + label::before
                  opacity 1
              label
                display block
                width .18rem
                height .18rem
                background #FFF
                border 1px solid $green_color
                border-radius .05rem
                margin-right .15rem
                &::before
                  content ''
                  display block
                  width .05rem
                  height .1rem
                  border-right 2px solid $green_color
                  border-bottom 2px solid $green_color
                  margin .01rem 0 0 .06rem
                  transform rotate(45deg)
                  opacity 0
      .right
        flex 1
        .scroll_wrap
          height 3.4rem
          .wrapper
            margin 0 .2rem
            display flex
            flex-wrap wrap
            height 3.4rem
            .item
              font-size .16rem
              width 1.78rem
              margin 0 .18rem .2rem 0
              cursor move
              position relative
              img,.mask
                width 1.78rem
                height 1.04rem
              p
                margin-top .15rem
                width 100%
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
              .detail
                color $green_color
                margin-top .1rem
                cursor pointer
              .mask
                background rgba(0, 0, 0, .6)
                position absolute
                left 0
                top 0
                display none
            .disabled
              cursor default
              .mask
                display block
  .detail_wrap
    padding 20px
    padding-right 0
    height 560px
    overflow hidden
    .title
      font-size 22px
      padding-bottom 20px
      margin-right 20px
      border-bottom 1px solid #DDD
    .detail
      display flex
      margin-right 20px
      .tutorial_wrap
        width 340px
        height 203px
        z-index 2
      .placeholder_img
        width 340px
        height 203px
        position absolute
        top 48px
        left 0
        z-index 1
      .info
        font-size 18px
        padding 20px 0 0 20px
        p
          margin-bottom 20px
    .description
      font-size 18px
      padding 25px 0
</style>
